export const updateWorkbinCodes = (workbinProducerCodes) => ({
  type: "UPDATE_WORKBIN_CODES",
  payload: workbinProducerCodes,
});
